import { useEffect, useState } from "react";

const links = [
  { label: "阅读体验", href: "#features" },
  { label: "热门韩漫", href: "#showcase" },
  { label: "体验预览", href: "#reader" },
  { label: "题材分类", href: "#categories" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a
          href="#top"
          className="flex items-center gap-2.5"
          aria-label="韩漫在线 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            韩漫在线
          </span>
        </a>

        <ul
          className={`hidden items-center gap-1 md:flex ${
            scrolled ? "text-foreground-800" : "text-background-50"
          }`}
        >
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors hover:bg-primary-500/10 hover:text-primary-600"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#showcase"
            className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
              scrolled
                ? "border-foreground-300 text-foreground-800 hover:border-primary-500 hover:text-primary-600"
                : "border-background-50/50 text-background-50 hover:bg-background-50/10"
            }`}
          >
            开始阅读
          </a>
          <a
            href="#reader"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            体验预览
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
            scrolled || open
              ? "text-foreground-900"
              : "text-background-50"
          }`}
          aria-label="切换菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <ul className="flex flex-col gap-1 py-2">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="flex gap-3 px-3 pb-2">
            <a
              href="#showcase"
              onClick={() => setOpen(false)}
              className="flex-1 whitespace-nowrap rounded-full border border-foreground-300 px-4 py-2 text-center text-sm font-medium text-foreground-800"
            >
              开始阅读
            </a>
            <a
              href="#reader"
              onClick={() => setOpen(false)}
              className="flex-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-center text-sm font-medium text-background-50"
            >
              体验预览
            </a>
          </div>
        </div>
      )}
    </header>
  );
}